import { render, staticRenderFns } from "./ResultTableContainer.vue?vue&type=template&id=1309d650&"
import script from "./ResultTableContainer.vue?vue&type=script&lang=ts&"
export * from "./ResultTableContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports